import { LinkProps } from "next/link";

export type Size = {
  name: string;
  sublabel?: string | null | undefined;
  sizeReductionLabel: string;
  showReduced: boolean;
  unavailable: boolean;
  isSelected: boolean;
  sizeHeadline: string;
  url: LinkProps["href"];
};

export const fitFinderAndSizeChartPositionValues = [
  "default",
  "belowHeadline",
] as const;

export type FitFinderAndSizeChartPositionValue =
  (typeof fitFinderAndSizeChartPositionValues)[number];
